// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { Table, Button, Form, InputGroup, Pagination, Badge, Spinner } from "react-bootstrap";
// import api from "../../api";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "./MyFormResultsPage.css";

// // Phase 3C, §28. Reuses GET /api/my-form-assignments (Phase 3B, hard-scoped
// // to the caller's own user_id) rather than a separate endpoint — Phase 3C
// // only extended that same query's SELECT list with the latest submission's
// // score/review summary columns (services/formRuntimeService.js). No
// // performance trends/charts here, only a submitted-forms list with results.
// const SCORE_STATUS_VARIANT = { NOT_APPLICABLE: "secondary", PENDING: "secondary", PARTIALLY_SCORED: "warning", CALCULATED: "info", FINALIZED: "success" };
// const REVIEW_STATUS_VARIANT = { NOT_REQUIRED: "secondary", PENDING_REVIEW: "warning", PENDING_APPROVAL: "warning", APPROVED: "success", REJECTED: "danger", CHANGES_REQUESTED: "danger" };

// function useRolePrefix() {
//   const path = window.location.pathname;
//   const match = path.match(/^\/([^/]+)\//);
//   return match ? match[1] : "admin";
// }

// export default function MyFormResultsPage() {
//   const navigate = useNavigate();
//   const rolePrefix = useRolePrefix();

//   const [rows, setRows] = useState([]);
//   const [total, setTotal] = useState(0);
//   const [loading, setLoading] = useState(false);

//   const [formTypeFilter, setFormTypeFilter] = useState("");
//   const [projectFilter, setProjectFilter] = useState("");
//   const [search, setSearch] = useState("");
//   const [formTypes, setFormTypes] = useState([]);
//   const [projects, setProjects] = useState([]);

//   const [currentPage, setCurrentPage] = useState(1);
//   const pageSize = 20;

//   useEffect(() => {
//     fetchResults();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [formTypeFilter, projectFilter, search, currentPage]);

//   useEffect(() => {
//     Promise.all([
//       api.get("/form-types", { params: { is_active: 1, pageSize: 200 } }).catch(() => null),
//       api.get("/projects", { params: { is_active: 1, pageSize: 200 } }).catch(() => null),
//     ]).then(([typeRes, projectRes]) => {
//       setFormTypes(Array.isArray(typeRes?.data?.data) ? typeRes.data.data : []);
//       setProjects(Array.isArray(projectRes?.data?.data) ? projectRes.data.data : []);
//     });
//   }, []);

//   const fetchResults = async () => {
//     try {
//       setLoading(true);
//       const res = await api.get("/my-form-assignments", {
//         params: {
//           status: "submitted",
//           form_type_id: formTypeFilter || undefined,
//           project_id: projectFilter || undefined,
//           search: search || undefined,
//           page: currentPage,
//           pageSize,
//         },
//       });
//       setRows(Array.isArray(res.data?.data) ? res.data.data : []);
//       setTotal(res.data?.meta?.total || 0);
//     } catch (err) {
//       console.error("Fetch my form results error:", err);
//       toast.error(err.response?.data?.message || "Failed to fetch your form results");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const totalPages = Math.max(Math.ceil(total / pageSize), 1);

//   const openResult = (row) => {
//     if (!row.latest_submission_id) return;
//     navigate(`/${rolePrefix}/form-submissions/${row.latest_submission_id}`);
//   };

//   return (
//     <div className="unit-page myformresults-theme">
//       <ToastContainer position="top-right" autoClose={3000} />

//       <div className="unit-header">
//         <div>
//           <div className="unit-page-label">Forms</div>
//           <h2>My Form Results</h2>
//           <p>Scores, grades and review status for the forms you have submitted.</p>
//         </div>
//         <div className="unit-header-actions">
//           <Button className="unit-btn unit-btn-light" onClick={fetchResults}>
//             <i className="fa-solid fa-rotate" aria-hidden="true"></i>
//             Refresh
//           </Button>
//         </div>
//       </div>

//       <div className="unit-card">
//         <div className="unit-toolbar" style={{ flexWrap: "wrap", gap: 8 }}>
//           <div>
//             <h5>
//               <i className="fa-solid fa-clipboard-check myfr-list-icon" aria-hidden="true"></i>
//               Submitted Forms
//             </h5>
//           </div>
//           <div className="unit-toolbar-actions" style={{ flexWrap: "wrap", gap: 8 }}>
//             <InputGroup className="unit-search" style={{ maxWidth: 200 }}>
//               <InputGroup.Text aria-hidden="true">
//                 <i className="fa-solid fa-magnifying-glass"></i>
//               </InputGroup.Text>
//               <Form.Control
//                 placeholder="Search..."
//                 aria-label="Search your submitted forms"
//                 value={search}
//                 onChange={(e) => { setCurrentPage(1); setSearch(e.target.value); }}
//               />
//             </InputGroup>
//             <Form.Select style={{ maxWidth: 170 }} value={formTypeFilter} onChange={(e) => { setCurrentPage(1); setFormTypeFilter(e.target.value); }}>
//               <option value="">All Form Types</option>
//               {formTypes.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
//             </Form.Select>
//             <Form.Select style={{ maxWidth: 170 }} value={projectFilter} onChange={(e) => { setCurrentPage(1); setProjectFilter(e.target.value); }}>
//               <option value="">All Projects</option>
//               {projects.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
//             </Form.Select>
//           </div>
//         </div>

//         <div className="unit-table-wrapper">
//           {loading ? (
//             <div className="unit-loader"><Spinner animation="border" /><p>Loading your results...</p></div>
//           ) : (
//             <Table responsive className="unit-table">
//               <thead>
//                 <tr>
//                   <th>Form</th>
//                   <th>Scope</th>
//                   <th>Submitted</th>
//                   <th>Score</th>
//                   <th>Result</th>
//                   <th>Status</th>
//                   <th className="text-end">Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {rows.length > 0 ? rows.map((row) => (
//                   <tr key={row.assignment_user_id}>
//                     <td>
//                       <div className="myfr-form-cell">
//                         <strong>{row.form_name}</strong>
//                         <Badge bg="light" text="dark" className="myfr-type-badge">{row.form_type_name}</Badge>
//                       </div>
//                     </td>
//                     <td className="small text-muted">{row.project_name || "—"}{row.project_module_name ? ` / ${row.project_module_name}` : ""}</td>
//                     <td className="small">{row.completed_at ? new Date(row.completed_at).toLocaleDateString() : "—"}</td>
//                     <td className="small">
//                       <span className="myfr-score-pill">
//                         {row.latest_percentage != null ? `${row.latest_percentage}%` : "—"}
//                       </span>
//                       {row.latest_grade && <span className="text-muted myfr-grade"> ({row.latest_grade})</span>}
//                     </td>
//                     <td className="small">{row.latest_result_label || "—"}</td>
//                     <td>
//                       <Badge bg={SCORE_STATUS_VARIANT[row.latest_score_status] || "secondary"} className="myfr-status-badge me-1">
//                         {row.latest_finalized_at ? "Final" : row.latest_score_status}
//                       </Badge>
//                       {row.latest_review_status && row.latest_review_status !== "NOT_REQUIRED" && (
//                         <Badge bg={REVIEW_STATUS_VARIANT[row.latest_review_status] || "secondary"} className="myfr-status-badge">{row.latest_review_status}</Badge>
//                       )}
//                     </td>
//                     <td>
//                       <div className="unit-actions">
//                         <Button
//                           size="sm"
//                           variant="outline-secondary"
//                           className="myfr-view-btn"
//                           disabled={!row.latest_submission_id}
//                           onClick={() => openResult(row)}
//                           aria-label={`View result for ${row.form_name || "form"}`}
//                         >
//                           <i className="fa-solid fa-eye" aria-hidden="true"></i>
//                           View
//                         </Button>
//                       </div>
//                     </td>
//                   </tr>
//                 )) : (
//                   <tr>
//                     <td colSpan="7">
//                       <div className="unit-empty">
//                         <div className="unit-empty-icon">
//                           <i className="fa-solid fa-inbox" aria-hidden="true"></i>
//                         </div>
//                         <h5>No submitted forms found</h5>
//                         <p>Try another filter, or check back after submitting a form.</p>
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </Table>
//           )}
//         </div>

//         <div className="unit-footer">
//           <div className="unit-count-text">Showing <strong>{rows.length}</strong> of <strong>{total}</strong> result(s)</div>
//           {totalPages > 1 && (
//             <Pagination className="unit-pagination">
//               <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)} />
//               {[...Array(totalPages)].map((_, i) => (
//                 <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>{i + 1}</Pagination.Item>
//               ))}
//               <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)} />
//             </Pagination>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }







import React, { useEffect, useState } from "react";
import { compactPageItems } from "../../components/ui/compactPagination";
import { useNavigate } from "react-router-dom";
import { Table, Button, Form, InputGroup, Pagination, Spinner } from "react-bootstrap";
import api from "../../api";
import { toast } from "react-toastify";
import { initialsOf, avatarColorFor } from "../../utils/avatar";
import "./MyFormResultsPage.css";

// Phase 3C, §28. Reuses GET /api/my-form-assignments (Phase 3B, hard-scoped
// to the caller's own user_id) rather than a separate endpoint — Phase 3C
// only extended that same query's SELECT list with the latest submission's
// score/review summary columns (services/formRuntimeService.js). No
// performance trends/charts here, only a submitted-forms list with results.
const REVIEW_STATUS_VARIANT = { NOT_REQUIRED: "secondary", PENDING_REVIEW: "warning", PENDING_APPROVAL: "warning", APPROVED: "success", REJECTED: "danger", CHANGES_REQUESTED: "danger" };
const REVIEW_STATUS_LABEL = { PENDING_REVIEW: "Pending Review", PENDING_APPROVAL: "Pending Approval", APPROVED: "Reviewed", REJECTED: "Rejected", CHANGES_REQUESTED: "Changes Requested" };

function useRolePrefix() {
  const path = window.location.pathname;
  const match = path.match(/^\/([^/]+)\//);
  return match ? match[1] : "admin";
}

export default function MyFormResultsPage({ embedded = false } = {}) {
  const navigate = useNavigate();
  const rolePrefix = useRolePrefix();

  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const [formTypeFilter, setFormTypeFilter] = useState("");
  const [projectFilter, setProjectFilter] = useState("");
  const [search, setSearch] = useState("");
  const [formTypes, setFormTypes] = useState([]);
  const [projects, setProjects] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;

  useEffect(() => {
    fetchResults();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formTypeFilter, projectFilter, search, currentPage]);

  useEffect(() => {
    Promise.all([
      api.get("/form-types", { params: { is_active: 1, pageSize: 200 } }).catch(() => null),
      api.get("/projects", { params: { is_active: 1, pageSize: 200 } }).catch(() => null),
    ]).then(([typeRes, projectRes]) => {
      setFormTypes(Array.isArray(typeRes?.data?.data) ? typeRes.data.data : []);
      setProjects(Array.isArray(projectRes?.data?.data) ? projectRes.data.data : []);
    });
  }, []);

  const fetchResults = async () => {
    try {
      setLoading(true);
      const res = await api.get("/my-form-assignments", {
        params: {
          status: "submitted",
          form_type_id: formTypeFilter || undefined,
          project_id: projectFilter || undefined,
          search: search || undefined,
          page: currentPage,
          pageSize,
        },
      });
      setRows(Array.isArray(res.data?.data) ? res.data.data : []);
      setTotal(res.data?.meta?.total || 0);
    } catch (err) {
      console.error("Fetch my form results error:", err);
      toast.error(err.response?.data?.message || "Failed to fetch your form results");
    } finally {
      setLoading(false);
    }
  };

  const totalPages = Math.max(Math.ceil(total / pageSize), 1);

  const openResult = (row) => {
    if (!row.latest_submission_id) return;
    navigate(`/${rolePrefix}/form-submissions/${row.latest_submission_id}`);
  };

  return (
    <div className={`unit-page myformresults-theme ${embedded ? "fa-embedded" : ""}`}>

      <div className="unit-header">
        {!embedded && (
          <div>
            <div className="unit-page-label">Forms</div>
            <h2>My Form Results</h2>
            <p>Scores, grades and review status for the forms you have submitted.</p>
          </div>
        )}
        <div className="unit-header-actions">
          <Button className="unit-btn unit-btn-light" onClick={fetchResults}>
            <i className="fa-solid fa-rotate" aria-hidden="true"></i>
            Refresh
          </Button>
        </div>
      </div>

      <div className="unit-stats-row">
        <div className="unit-stat-card myresults-stat-blue">
          <div className="myresults-stat-content">
            <div className="myresults-stat-text">
              <span>Total Results</span>
              <strong>{total}</strong>
            </div>

            <div className="myresults-stat-icon">
              <i className="fa-solid fa-square-poll-vertical" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card myresults-stat-purple">
          <div className="myresults-stat-content">
            <div className="myresults-stat-text">
              <span>Current Page</span>
              <strong>{currentPage}</strong>
            </div>

            <div className="myresults-stat-icon">
              <i className="fa-solid fa-file-lines" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card myresults-stat-green">
          <div className="myresults-stat-content">
            <div className="myresults-stat-text">
              <span>Rows Per Page</span>
              <strong>{pageSize}</strong>
            </div>

            <div className="myresults-stat-icon">
              <i className="fa-solid fa-table-list" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>

      <div className="unit-card">
        <div className="unit-toolbar myresults-toolbar">
          <div className="myresults-section-title">
            <div className="myresults-section-icon">
              <i className="fa-solid fa-clipboard-check" aria-hidden="true"></i>
            </div>

            <div className="myresults-section-copy">
              <h5>Submitted Forms</h5>
              <p>Review your submitted forms, final scores, grades and review status.</p>
            </div>
          </div>

          <div className="unit-toolbar-actions myresults-filters-row">
            <InputGroup className="unit-search myresults-search">
              <InputGroup.Text aria-hidden="true">
                <i className="fa-solid fa-magnifying-glass"></i>
              </InputGroup.Text>
              <Form.Control
                placeholder="Search..."
                aria-label="Search your submitted forms"
                value={search}
                onChange={(e) => {
                  setCurrentPage(1);
                  setSearch(e.target.value);
                }}
              />

              {search && (
                <Button
                  className="myresults-clear-search"
                  onClick={() => {
                    setCurrentPage(1);
                    setSearch("");
                  }}
                  title="Clear search"
                  aria-label="Clear search"
                >
                  <i className="fa-solid fa-xmark" aria-hidden="true"></i>
                </Button>
              )}
            </InputGroup>
            <div className="myresults-select-wrap">
              <i className="fa-solid fa-shapes myresults-select-icon" aria-hidden="true"></i>
              <Form.Select
                className="myresults-filter-select"
                value={formTypeFilter}
                onChange={(e) => {
                  setCurrentPage(1);
                  setFormTypeFilter(e.target.value);
                }}
              >
                <option value="">All Form Types</option>
                {formTypes.map((t) => (
                  <option key={t.id} value={t.id}>
                    {t.name}
                  </option>
                ))}
              </Form.Select>
            </div>

            <div className="myresults-select-wrap">
              <i className="fa-solid fa-diagram-project myresults-select-icon" aria-hidden="true"></i>
              <Form.Select
                className="myresults-filter-select"
                value={projectFilter}
                onChange={(e) => {
                  setCurrentPage(1);
                  setProjectFilter(e.target.value);
                }}
              >
                <option value="">All Projects</option>
                {projects.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.name}
                  </option>
                ))}
              </Form.Select>
            </div>
          </div>
        </div>

        <div className="unit-table-wrapper">
          {loading ? (
            <div className="unit-loader"><Spinner animation="border" /><p>Loading your results...</p></div>
          ) : (
            <Table responsive className="unit-table myfr-table-v2">
              <thead>
                <tr>
                  <th>Form</th>
                  <th>Assignment</th>
                  <th>Submitted On</th>
                  <th>Submission</th>
                  <th>Review</th>
                  <th>Score</th>
                  <th>Reviewer</th>
                  <th className="text-end">Action</th>
                </tr>
              </thead>
              <tbody>
                {rows.length > 0 ? rows.map((row) => (
                  <tr key={row.assignment_user_id}>
                    <td>
                      <strong>{row.form_name}</strong>
                      <div className="myfr-type-pill">{row.form_type_name}</div>
                    </td>
                    <td className="small">{row.assignment_title || "—"}</td>
                    <td className="small">{row.completed_at ? new Date(row.completed_at).toLocaleDateString() : "—"}</td>
                    <td>
                      <span className="myfr-pill myfr-pill-success"><i className="myfr-dot" aria-hidden="true"></i>Submitted</span>
                    </td>
                    <td>
                      {row.latest_review_status && row.latest_review_status !== "NOT_REQUIRED" ? (
                        <span className={`myfr-pill myfr-pill-${REVIEW_STATUS_VARIANT[row.latest_review_status] || "secondary"}`}>
                          <i className="myfr-dot" aria-hidden="true"></i>{REVIEW_STATUS_LABEL[row.latest_review_status] || row.latest_review_status}
                        </span>
                      ) : <span className="text-muted small">N/A</span>}
                    </td>
                    <td className="small">
                      {row.latest_percentage != null ? <strong>{row.latest_percentage}%</strong> : <span className="text-muted">—</span>}
                      {row.latest_grade && <span className="text-muted myfr-grade"> ({row.latest_grade})</span>}
                    </td>
                    <td className="small">
                      {row.latest_reviewer_name ? (
                        <>
                          <span className="myfr-avatar" style={{ background: avatarColorFor(row.latest_reviewer_name) }}>{initialsOf(row.latest_reviewer_name)}</span>
                          {row.latest_reviewer_name}
                        </>
                      ) : <span className="text-muted">—</span>}
                    </td>
                    <td className="text-end">
                      <Button
                        size="sm"
                        className="unit-btn unit-btn-light myfr-view-btn"
                        disabled={!row.latest_submission_id}
                        onClick={() => openResult(row)}
                        aria-label={`View result for ${row.form_name || "form"}`}
                      >
                        View Result
                      </Button>
                    </td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan="8">
                      <div className="unit-empty">
                        <div className="unit-empty-icon">
                          <i className="fa-solid fa-inbox" aria-hidden="true"></i>
                        </div>
                        <h5>No submitted forms found</h5>
                        <p>Try another filter, or check back after submitting a form.</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </div>

        <div className="unit-footer">
          <div className="unit-count-text">Showing <strong>{rows.length}</strong> of <strong>{total}</strong> result(s)</div>
          {totalPages > 1 && (
            <Pagination className="unit-pagination">
              <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)} />
              {compactPageItems([...Array(totalPages)].map((_, i) => (
                <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>{i + 1}</Pagination.Item>
              )), currentPage)}
              <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)} />
            </Pagination>
          )}
        </div>
      </div>
    </div>
  );
}
